module.exports = "img/button-text-bulleted-list.78818b2.svg";